







import Popup from '@/views/organisms/Popup.vue'
import BlueButton from '@/views/atoms/BlueButton.vue'
import ItemChoiceCheckBox from '@/views/organisms/ItemChoiceCheckBox.vue'
import ApiClient from '@/common/api'
import store from '@/store'

export default
  components: {
    Popup
    BlueButton
    ItemChoiceCheckBox
    
  }

  props:
    list:
      type: Object
      default: {}
    title:
      type: String
      default: ''
    colorGreen:
      type: Boolean
      default: false
    labelList:
      type: Object
      default: []
    isCustomsBroker:
      type: Boolean
      default: false

  methods: {
    close_popup: (e) ->
      @$emit('close_popup')

    change: (b, v) ->
      @list[v] = b
      if @colorGreen
        store.dispatch('setPartnerDisplayItems', @list)
      else
        if @isCustomsBroker
          store.dispatch('setCustomsBrokerDisplayItems', @list)
        else
          store.dispatch('setDisplayItems', @list)
  }
